import type { ICGTemplateVariation } from '~/modules/campaign-template/types';
import type { ICampaignGroup } from '~/modules/campaign-group/types';
import type { ICampaignTableProperty } from '~/presentation/common';

import { MetricProperty, StartTimeProperty, StatusProperty } from '~/modules/campaign';
import { useAnalyticCampaignGroupContext } from '~/modules/campaign-analytics';
import { useGCampaignTableCellContext } from '~/presentation/common';
import { CGTemplateVariantLabel } from './CGTemplateVariantLabel';
import { CGTemplateAction } from './CGTemplateAction';
import { useMemo } from 'react';

interface CGTemplateVariantPropertyProps {
  campaignGroup: ICampaignGroup;
  variant: ICGTemplateVariation;
}

export const CGTemplateVariantProperty: React.FC<CGTemplateVariantPropertyProps> = (props) => {
  const { variant, campaignGroup } = props;
  const { item } = useGCampaignTableCellContext<ICampaignTableProperty>();
  const { metrics, isEmptyMetricData } = useAnalyticCampaignGroupContext();

  const metric = useMemo(() => {
    if (isEmptyMetricData) return;

    return metrics.find((m) => m.variantKey === variant.variantKey);
  }, [isEmptyMetricData, metrics, variant.variantKey]);

  switch (item.id) {
    case 'label':
      return <CGTemplateVariantLabel variant={variant} />;
    case 'totalVisitor':
      return <MetricProperty metric={metric} functionKey="getTotalVisitorMetric" />;
    case 'conversionRate':
      return <MetricProperty metric={metric} functionKey="getConversionRateMetric" />;
    case 'revenueRate':
      return <MetricProperty metric={metric} functionKey="getTotalRevenueMetric" />;
    case 'startTime':
      return <StartTimeProperty startedAt={campaignGroup?.startedAt} />;
    case 'status':
      return <StatusProperty status={campaignGroup.status} />;
    case 'action':
      return <CGTemplateAction campaignGroup={campaignGroup} />;
    default:
      return null;
  }
};
